export const SET_ALL_CATEGORIES = 'PRO/SET_ALL_CATEGORIES'
export type SET_ALL_CATEGORIES = typeof SET_ALL_CATEGORIES
